/* eslint-disable global-require */
/* eslint-disable react/react-in-jsx-scope */
import { Button, CardMedia, createStyles, makeStyles, Theme } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: 250,
      width: "25%",
      position: "relative",
      background: "white",
      margin: 20,
      marginTop: -80,
      border: "1px solid #757a93",
      borderRadius: 20,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 20px 0px 20px",
      [theme.breakpoints.down("xs")]: {
        width:"auto"
      },
    },
    cardHeader: {
      height: 105,
      width: 105,
      borderRadius: "50%",
      display: "flex",
      marginTop: -50,
      background: "#ffff",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: 5,
    },
    cardSubHeader: {
      border: "1px solid #757a93",
      height: 95,
      width: 95,
      borderRadius: "50%",
      backgroundColor: "rgba(98, 98, 98, 0.37)",
    },
    cardBody: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: 320,
      position: "relative",
      top: -3,
    },
    bodyLabel: {
      color: "#f2994a",
      fontWeight: 600,
      fontSize: 16,
      marginTop: 20,
    },
    description: {
      width: "315px",
      height: "63px",
      marginTop: -4,
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#757a93",
      lineHeight: 1.5,
    },
    disabled: {
      opacity: "41%",
      "&.MuiButton-contained": {
        color: "#fff",
        backgroundColor: "#399ebf",
      },
    },
    button: {
      width: "15em",
      height: "30px",
      position: "relative",
      bottom: -10,
      [theme.breakpoints.down("xs")]: {
        width: "20em",
      },
    },
  })
);

type Props = {
  item: {
    image: string;
    title: any;
    description: any;
    button: any;
    url: string;
    disabled: boolean;
  };
};

const Card = ({ item }: Props) => {
  const classes = useStyles();
  const navigator = useNavigate();
  const handleNavigation = () => navigator(`${item.url}`);
  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <CardMedia className={classes.cardSubHeader} image={require(`../../../assets/images/${item.image}`).default} />
      </div>
      <div className={classes.cardBody}>
        <p className={classes.bodyLabel}>{item?.title}</p>
        <p className={classes.description}>{item?.description}</p>
        <Button
          variant="contained"
          color="primary"
          disabled={item.disabled}
          classes={{
            disabled: classes.disabled,
            root: classes.button,
          }}
          onClick={handleNavigation}
        >
          {item?.button}
        </Button>
      </div>
    </div>
  );
};

export default Card;
